// Defines roles for invitations within the organization
export type InviteRoleKey = 'project_manager' | 'foreman';

/**
 * Metadata for a user role within an organization.
 */
export interface InviteRole {
  /** Key identifying the role */
  key: InviteRoleKey;
  /** Display name for the role */
  displayName: string;
  /** ContactType to filter existing contacts */
  contactType: 'Staff' | 'Ironworker';
}

/**
 * Map of all invitation roles supported by the system.
 */
export const INVITE_ROLES: Record<InviteRoleKey, InviteRole> = {
  project_manager: {
    key: 'project_manager',
    displayName: 'Project Manager',
    contactType: 'Staff',
  },
  foreman: {
    key: 'foreman',
    displayName: 'Foreman',
    contactType: 'Ironworker',
  },
};